var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8126 10.9371C17.1876 14.0621 14.8315 17.0041 11.5242 17.662C8.21702 18.3198 4.86092 16.7815 3.20046 13.8466C1.54 10.9118 1.94992 7.24275 4.21716 4.74673C6.4844 2.25069 10.3126 1.56209 13.4376 2.81209",
    stroke: "#363636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 9.6875L10.3125 12.8125L17.8125 4.6875",
    stroke: "#363636",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickIcon);
export default __webpack_public_path__ + "static/media/circleTickIcon.cb60052f922c9270bf099bd3fd3f4ac0.svg";
export { ForwardRef as ReactComponent };